module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBoldItalic.3fda80b8.ttf";